import { apiRequest } from '@/lib/api/client';
import type {
  AuditLogItem,
  CatalogAdminResponse,
  DraftUpdatePayload,
  ValidationResultResponse,
  VersionHistoryItem,
} from './types';

export const fetchAdminCatalog = (): Promise<CatalogAdminResponse> =>
  apiRequest<CatalogAdminResponse>('/owner/coverage/admin/catalog', {
    channel: 'platform',
  });

export const saveCatalogDraft = (payload: DraftUpdatePayload): Promise<CatalogAdminResponse> =>
  apiRequest<CatalogAdminResponse>('/owner/coverage/admin/draft', {
    method: 'PATCH',
    channel: 'platform',
    body: payload,
  });

export const validateCatalog = (): Promise<ValidationResultResponse> =>
  apiRequest<ValidationResultResponse>('/owner/coverage/admin/validate', {
    method: 'POST',
    channel: 'platform',
  });

export const publishCatalog = (comment: string): Promise<CatalogAdminResponse> =>
  apiRequest<CatalogAdminResponse>('/owner/coverage/admin/publish', {
    method: 'POST',
    channel: 'platform',
    body: { comment },
  });

export const resetCatalogDraft = (): Promise<CatalogAdminResponse> =>
  apiRequest<CatalogAdminResponse>('/owner/coverage/admin/reset', {
    method: 'POST',
    channel: 'platform',
  });

export const fetchCatalogHistory = (): Promise<{
  versions: VersionHistoryItem[];
  audits: AuditLogItem[];
}> =>
  apiRequest<{ versions: VersionHistoryItem[]; audits: AuditLogItem[] }>(
    '/owner/coverage/admin/history',
    {
      channel: 'platform',
    }
  );

export const rollbackCatalog = (
  targetVersionNumber: number,
  comment: string
): Promise<CatalogAdminResponse> =>
  apiRequest<CatalogAdminResponse>('/owner/coverage/admin/rollback', {
    method: 'POST',
    channel: 'platform',
    body: {
      target_version_number: targetVersionNumber,
      comment,
    },
  });

export const exportCatalogUrl = '/api/owner/coverage/admin/export';
